//core
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ActionReducerMapBuilder} from "@reduxjs/toolkit/src/mapBuilders";
import {NoInfer} from "@reduxjs/toolkit/src/tsHelpers";

//service
import { cashierProfileService } from "../../../services/cashier/profile.service";

//actions
import { setGeneralProgressHide, setGeneralProgressShow, setGeneralSnackbarState } from "../../common/ui";
import { setUser } from "../../common/user";

export type profileSliceState = {
  updatePassword: {
    data: any,
    error: any,
    isFetching: boolean,
  },
};

const initialState: profileSliceState = {
  updatePassword: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const updatePasswordData = createAsyncThunk(
  'agent/profile/updatePassword',
  async (payload: any, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await cashierProfileService.updatePasswordData(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (response.ok && response.status === 201) {
        dispatch(
          setGeneralSnackbarState({
            open: true,
            type: 'success',
            message: 'success',
            messageKey: 'common.messages.created',
          })
        );
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        dispatch(
          setGeneralSnackbarState({
            open: true,
            type: 'warning',
            message: 'error',
            messageKey: 'common.messages.error',
          })
        )
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());

      return data;
    } catch (error) {
      dispatch(
        setGeneralSnackbarState({
          open: true,
          type: 'warning',
          message: 'error',
          messageKey: 'common.messages.error',
        })
      )
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

const profileSlice = createSlice({
  name: 'cashier/profile',
  initialState,
  reducers: {
    clearUpdatePasswordState: (state) => {
      state.updatePassword = initialState.updatePassword;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<profileSliceState>>) => {
    builder
      .addCase(updatePasswordData.pending, (state) => {
        state.updatePassword.isFetching = true;
        state.updatePassword.error = null;
      })
      .addCase(updatePasswordData.fulfilled, (state, action) => {
        state.updatePassword.isFetching = false;
        state.updatePassword.data = action.payload;
      })
      .addCase(updatePasswordData.rejected, (state, action) => {
        state.updatePassword.isFetching = false;
        state.updatePassword.error = action.payload;
      });
  },
});

export const {
  clearUpdatePasswordState,
} = profileSlice.actions;

export default profileSlice.reducer;
